<template>
  <v-app>
    <v-content>
      <!-- 全站提示 -->
      <v-snackbar v-model="snackbar.show" :color="snackbar.color" top right>
        {{ snackbar.text }}
        <v-icon @click="snackbar.show = false">mdi-close</v-icon>
      </v-snackbar>

      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {};
  },

  computed: {
    ...mapState("system", ["snackbar"])
  },
  watch: {},
  methods: {},

  mounted() {}
};
</script>
<style lang="scss">
@import "~@/assets/scss/App";
</style>
